import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPerDiemRateForChargeEditorQueryVariables = Types.Exact<{
  effectiveDate: Types.Scalars['LocalDate'];
  state: Types.Scalars['String'];
  county: Types.Scalars['String'];
}>;


export type GetPerDiemRateForChargeEditorQuery = { __typename?: 'QueryModel', perDiemRates?: { __typename?: 'PerDiemRatesQueryModel', rate?: { __typename?: 'PerDiemRate', mealsBillable: number, lodgingBillable: number, travelBillable: number } | null } | null };


export const GetPerDiemRateForChargeEditorDocument = gql`
    query GetPerDiemRateForChargeEditor($effectiveDate: LocalDate!, $state: String!, $county: String!) {
  perDiemRates {
    rate(effectiveDate: $effectiveDate, state: $state, county: $county) {
      mealsBillable
      lodgingBillable
      travelBillable
    }
  }
}
    `;

/**
 * __useGetPerDiemRateForChargeEditorQuery__
 *
 * To run a query within a React component, call `useGetPerDiemRateForChargeEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerDiemRateForChargeEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerDiemRateForChargeEditorQuery({
 *   variables: {
 *      effectiveDate: // value for 'effectiveDate'
 *      state: // value for 'state'
 *      county: // value for 'county'
 *   },
 * });
 */
export function useGetPerDiemRateForChargeEditorQuery(baseOptions: Apollo.QueryHookOptions<GetPerDiemRateForChargeEditorQuery, GetPerDiemRateForChargeEditorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerDiemRateForChargeEditorQuery, GetPerDiemRateForChargeEditorQueryVariables>(GetPerDiemRateForChargeEditorDocument, options);
      }
export function useGetPerDiemRateForChargeEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerDiemRateForChargeEditorQuery, GetPerDiemRateForChargeEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerDiemRateForChargeEditorQuery, GetPerDiemRateForChargeEditorQueryVariables>(GetPerDiemRateForChargeEditorDocument, options);
        }
export type GetPerDiemRateForChargeEditorQueryHookResult = ReturnType<typeof useGetPerDiemRateForChargeEditorQuery>;
export type GetPerDiemRateForChargeEditorLazyQueryHookResult = ReturnType<typeof useGetPerDiemRateForChargeEditorLazyQuery>;
export type GetPerDiemRateForChargeEditorQueryResult = Apollo.QueryResult<GetPerDiemRateForChargeEditorQuery, GetPerDiemRateForChargeEditorQueryVariables>;